import { render, staticRenderFns } from "./spbirimgostergedegerlendirmeformu.vue?vue&type=template&id=941814ce"
import script from "./spbirimgostergedegerlendirmeformu.vue?vue&type=script&lang=js"
export * from "./spbirimgostergedegerlendirmeformu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports